import { render, staticRenderFns } from "./IsimCategory.vue?vue&type=template&id=13ed926c&scoped=true&"
import script from "./IsimCategory.vue?vue&type=script&lang=js&"
export * from "./IsimCategory.vue?vue&type=script&lang=js&"
import style0 from "./IsimCategory.vue?vue&type=style&index=0&id=13ed926c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed926c",
  null
  
)

export default component.exports